// extracted by mini-css-extract-plugin
export var heroClass = "FinancePage-module--heroClass--510a2";